export const payment = {
	paymentTypes: {
		title: 'Select your Payment Type:',
		paymentType_CARD: 'Credit Card',
		paymentType_ACCOUNT: 'Open Account',
		paymentType_WELLS_FARGO: 'Wells Fargo Financing',
		paymentType_BANK_TRANSFER: 'Pay in Advance (PIA)',
		ccInfoMessage: 'You will be prompted to enter your credit card details after clicking the “Submit Order” button on the Review Order screen.'
	}
};